import React, { useState, useEffect } from 'react';
import '../Styling/landingPageNavigation.css';
import { StyleLinks } from '../../orgViews/OrgCommonComponents';
import { useIsMobile } from '../../custom-hooks/useIsMobile';
import { ChevronRight, X, Menu, Eye, ChevronsRight,ChartNoAxesCombined, Rocket, BookCheck, Repeat, GitCompareArrows, MapPinned, Combine, HandCoins, Contact, Receipt, BookLock, SquaresExclude, Store, Handshake, Clapperboard, MonitorCog, AudioWaveform, PhoneOutgoing, Plus, MapPin, ArrowRight } from 'lucide-react';
import { getOperationsProductByKey, OperationsProductKey } from '../Pages/operationsProductCatalog';
import { LOCAL_STORAGE_KEYS, RetrieveFromLocalCache, isValidString, setLocalStorageValue } from '../../common/CommonUtilsMethods';
import { navigateToLogin } from '../../auth/WorkyAuthNavigationService';
import { getOperationsProductSectionLink } from './PushToOperationsProductPage';
import { WORKY_WEB_APP_PATHS } from '../../WorkyWebAppPaths';
import {
    HOT_INTAKE_NEW_AGENCY_INCENTIVE_BANNER_COPY,
    HOT_INTAKE_NEW_AGENCY_INCENTIVE_BANNER_LEARN_MORE_LABEL,
    navigateToContactSalesPage,
} from './HotIntakeLeadFormShared';


type DropdownType = 'products' | 'careers' | 'resources' | null;
type HoveredButton = 'signin' | 'contact' | null;
const INCENTIVE_BANNER_DISMISSED_VALUE: string = 'dismissed';
const INCENTIVE_BANNER_OPEN_CLASS_NAME: string = 'lp-incentive-banner-open';

interface SlideData {
    readonly image: string;
    readonly title: string;
    readonly subtitle: string;
    readonly ctaText: string;
    readonly ctaLink: string;
}

const RESOURCES_SLIDER_DATA: readonly SlideData[] = [
    {
        image: './career-growth.jpg',
        title: 'Careers at Worky',
        subtitle: 'Join our fast-growing team',
        ctaText: 'View Roles',
        ctaLink: '/landing-page-careers'
    },
    {
        image: './learn-health.jpg',
        title: 'Blog & Insights',
        subtitle: 'Stay informed with expert content',
        ctaText: 'Read More',
        ctaLink: '/landing-page-blog'
    }
];

const SLIDER_DATA: readonly SlideData[] = [
    {
        image: './nurse-one.jpg',
        title: 'Healthcare Staffing',
        subtitle: 'Find qualified healthcare workers instantly',
        ctaText: 'Explore Now',
        ctaLink: '/landing-page-products'
    },
    {
        image: './worker-one.jpg',
        title: 'Operations Suite',
        subtitle: 'Manage your entire workforce with ease',
        ctaText: 'Learn More',
        ctaLink: '/landing-page-products'
    },
    {
        image: './sales-one.jpg',
        title: 'Sales Suite',
        subtitle: 'Accelerate your sales pipeline today',
        ctaText: 'Get Started',
        ctaLink: '/landing-page-products'
    }
];

// Centralized navigation data

const NAVIGATION_DATA = {
    products: {
        sections: [
            {
                title: 'SALES SUITE',
                gradient: 'linear-gradient(135deg, #f59e0b 0%, #ef4444 100%)',
                items: [
                    {
                        icon: Rocket,
                        title: 'Worky Leads',
                        subtitle: 'Lead generation and management',
                        link: '/landing-page-sales#worky-leads'
                    },
                    {
                        icon: Repeat,
                        title: 'Sales Tasks',
                        subtitle: 'Task management for sales',
                        link: '/landing-page-sales#worky-tasks'
                    },
                    {
                        icon: ChartNoAxesCombined,
                        title: 'Team Tracker',
                        subtitle: 'Sales performance tracking',
                        link: '/landing-page-sales#worky-team-tracker'
                    }
                ]
            },
            {
                title: 'OPERATIONS SUITE',
                gradient: 'linear-gradient(135deg, #0ea5e9 0%, #22c55e 100%)',
                items: [
                    {
                        icon: MapPinned,
                        title: 'Time Clock',
                        subtitle: 'Time tracking and attendance',
                        link: getOperationsProductSectionLink(OperationsProductKey.CLOCK)
                    },
                    {
                        icon: Combine,
                        title: 'Smart Match',
                        subtitle: getOperationsProductByKey(OperationsProductKey.SCHEDULE)?.subtitle ?? '',
                        link: getOperationsProductSectionLink(OperationsProductKey.SCHEDULE)
                    },
                    {
                        icon: HandCoins,
                        title: 'Worky Pay',
                        subtitle: 'Payroll and payment processing',
                        link: getOperationsProductSectionLink(OperationsProductKey.PAY)
                    },
                    {
                        icon: Contact,
                        title: 'Workforce',
                        subtitle: 'Workforce management platform',
                        link: getOperationsProductSectionLink(OperationsProductKey.WORKFORCE)
                    },
                    {
                        icon: Receipt,
                        title: 'Invoicing',
                        subtitle: 'Invoice creation and tracking',
                        link: getOperationsProductSectionLink(OperationsProductKey.INVOICES)
                    },
                    {
                        icon: BookLock,
                        title: 'Trust Vault',
                        subtitle: getOperationsProductByKey(OperationsProductKey.TRUST_VAULT)?.subtitle ?? 'Secure credential and document management',
                        link: getOperationsProductSectionLink(OperationsProductKey.TRUST_VAULT)
                    }
                ]
            },
            {
                title: 'MARKETPLACE',
                gradient: 'linear-gradient(135deg, #6366f1 0%, #a855f7 100%)',
                items: [
                    {
                        icon: Store,
                        title: 'Marketplace',
                        subtitle: 'The perfect candidate everytime',
                        link: '/landing-page-marketplace#worky-marketplace'
                    },
                    {
                        icon: SquaresExclude,
                        title: 'Agency Finder',
                        subtitle: 'Find the perfect agency',
                        link: '/landing-page-marketplace#worky-agency-finder'
                    }
                ]
            }
        ]
    },
    resources: {
        sections: [
            {
                title: 'CAREERS',
                gradient: 'linear-gradient(135deg, #ec4899 0%, #8b5cf6 100%)',
                items: [
                    {
                        icon: Handshake,
                        title: 'Regional Sales Manager',
                        subtitle: 'Sales management position',
                        link: '/landing-page-careers#regional-sales-manager'
                    },
                    {
                        icon: MonitorCog,
                        title: 'Founding Engineer',
                        subtitle: 'Engineering position',
                        link: '/landing-page-careers#founding-engineer'
                    },
                    {
                        icon: Plus,
                        title: 'More Positions',
                        subtitle: 'View all positions',
                        link: '/landing-page-careers'
                    }
                ]
            },
            {
                title: 'BLOG',
                gradient: 'linear-gradient(135deg, #10b981 0%, #3b82f6 100%)',
                items: [
                    {
                        icon: AudioWaveform,
                        title: 'Healthcare',
                        subtitle: 'Healthcare agency guides',
                        link: '/landing-page-blog#healthcare'
                    },
                    {
                        icon: AudioWaveform,
                        title: 'Software',
                        subtitle: 'Buying & implementation guides',
                        link: '/landing-page-blog#software'
                    },
                    {
                        icon: AudioWaveform,
                        title: 'Scale',
                        subtitle: 'Owner systems for growth',
                        link: '/landing-page-blog#scale'
                    }
                ]
            },
            {
                title: 'COMPARE',
                gradient: 'linear-gradient(135deg, #f97316 0%, #dc2626 100%)',
                items: [
                    {
                        icon: GitCompareArrows,
                        title: 'Worky vs AlayaCare',
                        subtitle: 'Healthcare staffing vs home-care suite',
                        link: '/landing-page-compare/worky-vs-alayacare'
                    },
                    {
                        icon: GitCompareArrows,
                        title: 'Worky vs ShiftCare',
                        subtitle: 'Healthcare staffing vs visit management',
                        link: '/landing-page-compare/worky-vs-shiftcare'
                    },
                    {
                        icon: GitCompareArrows,
                        title: 'Worky vs CareSmartz360',
                        subtitle: 'Healthcare staffing vs home-care EVV',
                        link: '/landing-page-compare/worky-vs-caresmartz360'
                    },
                    {
                        icon: GitCompareArrows,
                        title: 'Worky vs AxisCare',
                        subtitle: 'Healthcare staffing vs private duty',
                        link: '/landing-page-compare/worky-vs-axiscare'
                    },
                    {
                        icon: GitCompareArrows,
                        title: 'Worky vs Evolia',
                        subtitle: 'Healthcare staffing vs internal WFM',
                        link: '/landing-page-compare/worky-vs-evolia'
                    }
                ]
            }
        ]
    },
};


interface ProductItemProps {
    readonly icon: React.ComponentType<{ readonly size?: number }>;
    readonly title: string;
    readonly subtitle: string;
    readonly gradient: string;
    readonly link?: string;
}

// Reusable component for product items — real <a href> so crawlers can follow nav destinations.
const ProductItem = ({ icon: Icon, title, subtitle, gradient, link }: ProductItemProps): React.ReactElement => {
    const content: React.ReactElement = (
        <>
            <div className='lp-dropdown-content-product-item-icon' style={{ background: gradient, color: 'white' }}>
                <Icon size={18} />
            </div>
            <div className='lp-dropdown-content-product-item-title-holder'>
                <div className='lp-dropdown-content-product-item-title'>{title}</div>
                <div className='lp-dropdown-content-product-item-subtitle'>{subtitle}</div>
            </div>
        </>
    );

    if (isValidString(link)) {
        return (
            <a href={link} className='lp-dropdown-content-product-item'>
                {content}
            </a>
        );
    }

    return (
        <div className='lp-dropdown-content-product-item' style={{ cursor: 'default' }}>
            {content}
        </div>
    );
};

// Reusable component for dropdown sections
interface DropdownSectionItem {
    readonly icon: React.ComponentType<{ readonly size?: number }>;
    readonly title: string;
    readonly subtitle: string;
    readonly link?: string;
}

interface DropdownSectionData {
    readonly title: string;
    readonly gradient: string;
    readonly items: readonly DropdownSectionItem[];
}

interface DropdownSectionProps {
    readonly section: DropdownSectionData;
    readonly isMobile: boolean;
}

const DropdownSection = ({ section, isMobile }: DropdownSectionProps): React.ReactElement => {
    const firstItemLink: string | undefined = section.items[0]?.link;
    const sectionHref: string | undefined = isValidString(firstItemLink)
        ? firstItemLink.split('#')[0]
        : undefined;

    return(
        <div className={isMobile ? "lp-mobile-dropdown-section" : "lp-dropdown-content-inner"}>
            {isValidString(sectionHref) ? (
                <a
                    href={sectionHref}
                    className="lp-dropdown-content-title"
                    style={{display:'flex', alignItems:'center', gap:'5px', cursor:'pointer', textDecoration:'none', color:'inherit'}}
                >
                    {section.title} <ChevronRight size={14} />
                </a>
            ) : (
                <div className="lp-dropdown-content-title" style={{display:'flex', alignItems:'center', gap:'5px'}}>
                    {section.title} <ChevronRight size={14} />
                </div>
            )}
            <div className='lp-dropdown-content-product-container'>
                {section.items.map((item: DropdownSectionItem, index: number) => (
                    <ProductItem
                        key={index}
                        icon={item.icon}
                        title={item.title}
                        subtitle={item.subtitle}
                        gradient={section.gradient}
                        link={item.link}
                    />
                ))}
            </div>
        </div>
    )
};

const LandingNavigation = () => {
    const [activeDropdown, setActiveDropdown] = useState<DropdownType>(null);
    const [isScrolled, setIsScrolled] = useState(false);
    const [hoveredButton, setHoveredButton] = useState<HoveredButton>(null);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [mobileActiveDropdown, setMobileActiveDropdown] = useState<DropdownType>(null);
    const [sliderIndex, setSliderIndex] = useState<number>(0);
    const [resourcesSliderIndex, setResourcesSliderIndex] = useState<number>(0);
    const isMobile = useIsMobile();
    const isContactSalesPage: boolean = window.location.pathname === WORKY_WEB_APP_PATHS.contactSales;

    const [isIncentiveBannerVisible, setIsIncentiveBannerVisible] = useState<boolean>(
        !isValidString(RetrieveFromLocalCache(LOCAL_STORAGE_KEYS.LANDING_INCENTIVE_BANNER_DISMISSED))
    );

    const dismissIncentiveBanner = (): void => {
        setLocalStorageValue({
            key: LOCAL_STORAGE_KEYS.LANDING_INCENTIVE_BANNER_DISMISSED,
            value: INCENTIVE_BANNER_DISMISSED_VALUE,
        });
        setIsIncentiveBannerVisible(false);
    };

    useEffect((): (() => void) => {
        document.documentElement.classList.toggle(
            INCENTIVE_BANNER_OPEN_CLASS_NAME,
            isIncentiveBannerVisible && !isContactSalesPage
        );
        return (): void => {
            document.documentElement.classList.remove(INCENTIVE_BANNER_OPEN_CLASS_NAME);
        };
    }, [isIncentiveBannerVisible, isContactSalesPage]);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 100);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        if (activeDropdown !== 'products') return;
        const interval = setInterval(() => {
            setSliderIndex(prev => (prev + 1) % SLIDER_DATA.length);
        }, 6000);
        return () => clearInterval(interval);
    }, [activeDropdown]);

    useEffect(() => {
        if (activeDropdown !== 'resources') return;
        const interval = setInterval(() => {
            setResourcesSliderIndex(prev => (prev + 1) % RESOURCES_SLIDER_DATA.length);
        }, 6000);
        return () => clearInterval(interval);
    }, [activeDropdown]);

    const handleMouseEnter = (dropdown: DropdownType) => {
        setActiveDropdown(dropdown);
    };

    const handleMouseLeave = () => {
        setActiveDropdown(null);
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
        if (isMobileMenuOpen) {
            setMobileActiveDropdown(null);
        }
    };

    const handleMobileDropdownToggle = (dropdown: DropdownType) => {
        setMobileActiveDropdown(mobileActiveDropdown === dropdown ? null : dropdown);
    };

    return (
        <>
            <StyleLinks/>
            {isIncentiveBannerVisible && !isContactSalesPage && (
                <div className={`lp-incentive-banner ${isMobile ? 'lp-incentive-banner-mobile' : ''}`} role='region' aria-label='New agency incentive'>
                    <p className='lp-incentive-banner-text'>
                        {HOT_INTAKE_NEW_AGENCY_INCENTIVE_BANNER_COPY}
                        {' '}
                        <button
                            type='button'
                            className='lp-incentive-banner-learn-more'
                            onClick={(): void => {
                                setIsMobileMenuOpen(false);
                                navigateToContactSalesPage();
                            }}
                        >
                            {HOT_INTAKE_NEW_AGENCY_INCENTIVE_BANNER_LEARN_MORE_LABEL}
                        </button>
                    </p>
                    <button
                        type='button'
                        className='lp-incentive-banner-close'
                        onClick={dismissIncentiveBanner}
                        aria-label='Dismiss incentive banner'
                    >
                        <X size={16} />
                    </button>
                </div>
            )}
            {isMobile ? (
                <>
                <div className={`lp-navigation-container-mobile ${isScrolled ? 'lp-navigation-mobile-scrolled' : ''} ${isMobileMenuOpen ? 'lp-navigation-mobile-expanded' : ''}`}>
                    <div className='lp-navigation-container-mobile-inner'>
                        <div className='lp-navigation-section-mobile' id='lp-navigation-section-mobile-left'>
                            <button style={{width: isScrolled ? '40px' : 'auto'}} className='lp-navigation-button-mobile' onClick={toggleMobileMenu}>
                                {isScrolled ? (isMobileMenuOpen ? <X size={18} /> : <Menu size={13} />) : (isMobileMenuOpen ? 'Close' : 'Menu')}
                            </button>
                        </div>

                        <div className="lp-navigation-logo-mobile" onClick={() => {
                            const currentPath = window.location.pathname;
                            if (currentPath === '/landing-page') {
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                            } else {
                                window.location.assign('/landing-page');
                            }
                        }}>worky</div>

                        <div className='lp-navigation-section-mobile' id='lp-navigation-section-mobile-right'>
                            {!isScrolled ? (
                                <button
                                    type="button"
                                    className='lp-navigation-button-mobile lp-navigation-signin-header-mobile'
                                    onClick={() => { void navigateToLogin(); }}
                                >
                                    Sign In
                                </button>
                            ) : null}
                            <button 
                                style={{width: isScrolled ? '40px' : 'auto'}} 
                                className='lp-navigation-button-mobile lp-cta-button'
                                onClick={navigateToContactSalesPage}
                            >
                                {isScrolled ? <PhoneOutgoing size={13} /> : 'Try Now'}
                            </button>
                        </div>
                    </div>

                    {isMobileMenuOpen && (
                        <div className='lp-mobile-menu-container'>
                            <div className='lp-mobile-menu-container-inner'>
                                <div className='lp-mobile-menu-container-inner-top'>
                                    <button 
                                        style={{justifyContent: 'flex-start', fontSize: '30px'}} 
                                        className={`lp-mobile-menu-button ${mobileActiveDropdown === 'products' ? 'active' : ''}`}
                                        onClick={() => handleMobileDropdownToggle('products')}
                                    >
                                        Products 
                                        <span className={`lp-chevron ${mobileActiveDropdown === 'products' ? 'rotated' : ''}`}>
                                            <ChevronRight size={25} color={mobileActiveDropdown === 'products' ? '#2c68bd' : '#7d7d7d'} />
                                        </span>
                                    </button>
                                    
                                    {mobileActiveDropdown === 'products' && (
                                        <div className='lp-mobile-dropdown-content'>
                                            <button onClick={() => window.location.assign('/landing-page-products')} className='lp-mobile-menu-dropdown-top-button'>View All</button>
                                            {NAVIGATION_DATA.products.sections.map((section, index) => (
                                                <DropdownSection key={index} section={section} isMobile={true} />
                                            ))}
                                        </div>
                                    )}

                                    <button 
                                        style={{justifyContent: 'flex-start', fontSize: '30px'}} 
                                        className={`lp-mobile-menu-button ${mobileActiveDropdown === 'resources' ? 'active' : ''}`}
                                        onClick={() => handleMobileDropdownToggle('resources')}
                                    >
                                        Resources 
                                        <span className={`lp-chevron ${mobileActiveDropdown === 'resources' ? 'rotated' : ''}`}>
                                            <ChevronRight size={25} color={mobileActiveDropdown === 'resources' ? '#2c68bd' : '#7d7d7d'} />
                                        </span>
                                    </button>

                                    {mobileActiveDropdown === 'resources' && (
                                        <div className='lp-mobile-dropdown-content'>
                                            <button onClick={() => window.location.assign('/landing-page-resources')} className='lp-mobile-menu-dropdown-top-button'>View All</button>
                                            {NAVIGATION_DATA.resources.sections.map((section, index) => (
                                                <DropdownSection key={index} section={section} isMobile={true} />
                                            ))}
                                        </div>
                                    )}

                                </div>
                                <div className='lp-mobile-menu-container-inner-bottom'>
                                    <button className='lp-mobile-menu-button' onClick={() => { void navigateToLogin(); }}>Sign In</button>
                                    <button className='lp-mobile-menu-button lp-cta-button' onClick={navigateToContactSalesPage}>Contact Sales</button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                </>
            ) : (
                <div className={`lp-navigation-container ${activeDropdown ? 'lp-navigation-expanded' : ''} ${isScrolled ? 'lp-navigation-scrolled' : ''}`} onMouseLeave={handleMouseLeave}>
                    <div className="lp-navigation">
                        <div id="lp-navigation-section-left" className="lp-navigation-section">
                            <button onClick={() => window.location.assign('/landing-page-products')} className={`lp-navigation-button ${activeDropdown === 'products' ? 'active' : ''}`} onMouseEnter={() => handleMouseEnter('products')}>
                                Products <span className={`lp-chevron ${activeDropdown === 'products' ? 'rotated' : ''}`}><ChevronRight size={14} color={activeDropdown === 'products' ? '#2c68bd' : '#7d7d7d'} /></span>
                            </button>

                            <button onClick={() => window.location.assign('/landing-page-resources')} className={`lp-navigation-button ${activeDropdown === 'resources' ? 'active' : ''}`} onMouseEnter={() => handleMouseEnter('resources')}>
                                Resources <span className={`lp-chevron ${activeDropdown === 'resources' ? 'rotated' : ''}`}><ChevronRight size={14} color={activeDropdown === 'resources' ? '#2c68bd' : '#7d7d7d'} /></span>
                            </button>
                        </div>

                        <div className="lp-navigation-section-middle">
                            <button onClick={() => {
                            const currentPath = window.location.pathname;
                            if (currentPath === '/landing-page') {
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                            } else {
                                window.location.assign('/landing-page');
                            }
                        }} className='lp-navigation-logo'>worky</button>
                        </div>

                        <div id="lp-navigation-section-right" className="lp-navigation-section">
                            <button className="lp-navigation-button" onMouseEnter={() => setHoveredButton('signin')} onMouseLeave={() => setHoveredButton(null)} onClick={() => { void navigateToLogin(); }}>
                                Sign In
                            </button>
                            <button 
                                className="lp-navigation-button lp-cta-button" 
                                onMouseEnter={() => setHoveredButton('contact')} 
                                onMouseLeave={() => setHoveredButton(null)}
                                onClick={navigateToContactSalesPage}
                            >
                                Contact <span className="lp-cta-icon">{hoveredButton === 'contact' ? <ChevronsRight size={14} color="#ffffff" /> : <ChevronRight size={14} color="#ffffff" />}</span>
                            </button>
                        </div>
                    </div>

                    {/* Dropdown Content Areas */}
                    <div className={`lp-dropdown-content ${activeDropdown ? 'visible' : ''}`}>
                        {activeDropdown === 'products' && (
                            <div className="lp-dropdown-panel lp-dropdown-products">
                                <div className="lp-dropdown-content-inner" style={{ width: '100%', height: '100%' }}>
                                    <div className="lp-dropdown-content-image-holder">
                                        {SLIDER_DATA.map((slide, index) => (
                                            <img
                                                key={index}
                                                src={slide.image}
                                                alt={slide.title}
                                                className={`lp-slider-img ${index === sliderIndex ? 'lp-slider-img-active' : ''}`}
                                            />
                                        ))}
                                        {!isScrolled ? (
                                            <div className="lp-slider-overlay">
                                                <div className="lp-slider-overlay-left">
                                                    <div className="lp-slider-overlay-title">{SLIDER_DATA[sliderIndex]?.title}</div>
                                                    <div className="lp-slider-overlay-subtitle">{SLIDER_DATA[sliderIndex]?.subtitle}</div>
                                                </div>
                                                <div className="lp-slider-indicators">
                                                    {SLIDER_DATA.map((_, index) => (
                                                        <button
                                                            key={index}
                                                            className={`lp-slider-dot ${index === sliderIndex ? 'lp-slider-dot-active' : ''}`}
                                                            onClick={() => setSliderIndex(index)}
                                                        />
                                                    ))}
                                                </div>
                                                <button
                                                    className="lp-slider-cta-btn"
                                                    onClick={() => window.location.assign(SLIDER_DATA[sliderIndex]?.ctaLink ?? '/')}
                                                >
                                                    <ArrowRight size={14} />
                                                </button>
                                            </div>
                                        ) : (
                                            <div className="lp-slider-overlay-scrolled">
                                                <button
                                                    className="lp-slider-cta-btn"
                                                    onClick={() => window.location.assign(SLIDER_DATA[sliderIndex]?.ctaLink ?? '/')}
                                                >
                                                    <ArrowRight size={14} />
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {NAVIGATION_DATA.products.sections.map((section, index) => (
                                    <DropdownSection key={index} section={section} isMobile={false} />
                                ))}
                            </div>
                        )}

                        {activeDropdown === 'resources' && (
                            <div className="lp-dropdown-panel lp-dropdown-resources">
                                <div className="lp-dropdown-content-inner" style={{ width: '100%', height: '100%' }}>
                                    <div className="lp-dropdown-content-image-holder">
                                        {RESOURCES_SLIDER_DATA.map((slide, index) => (
                                            <img
                                                key={index}
                                                src={slide.image}
                                                alt={slide.title}
                                                className={`lp-slider-img ${index === resourcesSliderIndex ? 'lp-slider-img-active' : ''}`}
                                            />
                                        ))}
                                        {!isScrolled ? (
                                            <div className="lp-slider-overlay">
                                                <div className="lp-slider-overlay-left">
                                                    <div className="lp-slider-overlay-title">{RESOURCES_SLIDER_DATA[resourcesSliderIndex]?.title}</div>
                                                    <div className="lp-slider-overlay-subtitle">{RESOURCES_SLIDER_DATA[resourcesSliderIndex]?.subtitle}</div>
                                                </div>
                                                <div className="lp-slider-indicators">
                                                    {RESOURCES_SLIDER_DATA.map((_, index) => (
                                                        <button
                                                            key={index}
                                                            className={`lp-slider-dot ${index === resourcesSliderIndex ? 'lp-slider-dot-active' : ''}`}
                                                            onClick={() => setResourcesSliderIndex(index)}
                                                        />
                                                    ))}
                                                </div>
                                                <button
                                                    className="lp-slider-cta-btn"
                                                    onClick={() => window.location.assign(RESOURCES_SLIDER_DATA[resourcesSliderIndex]?.ctaLink ?? '/')}
                                                >
                                                    <ArrowRight size={14} />
                                                </button>
                                            </div>
                                        ) : (
                                            <div className="lp-slider-overlay-scrolled">
                                                <button
                                                    className="lp-slider-cta-btn"
                                                    onClick={() => window.location.assign(RESOURCES_SLIDER_DATA[resourcesSliderIndex]?.ctaLink ?? '/')}
                                                >
                                                    <ArrowRight size={14} />
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {NAVIGATION_DATA.resources.sections.map((section, index) => (
                                    <DropdownSection key={index} section={section} isMobile={false} />
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            )}       


        </>
    );
};

export {LandingNavigation};